import { motion } from "framer-motion";

const ITEMS = [
  {
    name: "DFY WEBINAR FUNNEL",
    body: "Landing page + replay page built and launched. High-converting by design.",
  },
  {
    name: "DFY AD COPY & CREATIVES",
    body: "Compliance-friendly Meta ad copy and 3–5 creative variants ready to run.",
  },
  {
    name: "GHL CRM SNAPSHOT",
    body: "Full pipeline, speed-to-lead automation, and 90-day nurture installed in your sub-account.",
  },
  {
    name: "WEBINAR SCRIPT",
    body: "A compliance-friendly script for your niche. Problem → Proof → Method → Offer → CTA.",
  },
  {
    name: "4× COACHING CALLS",
    body: "Strategy, niche selection, offer refinement — with Dallas Bell directly.",
  },
  {
    name: "PERMANENT REGISTRY LIST",
    body: "Every registrant becomes a retargeting asset that compounds with every webinar.",
  },
  {
    name: "90-DAY NURTURE SEQUENCE",
    body: "Automated GHL follow-up so no lead goes cold.",
  },
];

export default function Deliverables() {
  return (
    <section
      className="relative py-32 md:py-48"
      data-testid="deliverables-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="mb-8 flex items-center gap-4"
        >
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#F0ECE4]/40">
            [005] —
          </span>
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#C9A84C]">
            WHAT YOU GET
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-display max-w-[1000px]"
          style={{ fontSize: "clamp(34px, 5vw, 78px)", lineHeight: 0.95, letterSpacing: "-0.035em" }}
        >
          Everything you need.
          <br />
          <span className="text-[#F0ECE4]/50">Nothing you have to figure out.</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="mt-6 max-w-[560px] font-body text-[15px] leading-[1.75] text-[#F0ECE4]/55"
        >
          WAM is done-for-you. We build it, set it up, and hand you the keys.
        </motion.p>

        <ul className="mt-20">
          {ITEMS.map((item, i) => (
            <motion.li
              key={item.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.7, delay: i * 0.09, ease: [0.16, 1, 0.3, 1] }}
              className="group grid grid-cols-[auto_60px_1fr] md:grid-cols-[60px_80px_1fr_2fr] items-baseline gap-4 md:gap-8 border-t wam-hairline py-6 md:py-8 transition-colors hover:bg-white/[0.015]"
              data-testid={`deliverable-${i}`}
            >
              <span className="font-mono text-[10px] tracking-[0.28em] text-[#F0ECE4]/40">
                /{String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-display text-[#C9A84C] text-[22px] transition-transform group-hover:translate-x-2">
                →
              </span>
              <span className="font-display text-[18px] md:text-[24px] tracking-[-0.02em]">
                {item.name}
              </span>
              <span className="font-body text-[14px] leading-[1.7] text-[#F0ECE4]/60 col-span-3 md:col-span-1 md:col-start-4">
                {item.body}
              </span>
            </motion.li>
          ))}
          <li className="border-t wam-hairline" />
        </ul>
      </div>
    </section>
  );
}
